import React, { useState, useLayoutEffect, Suspense, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import Log from "../utils/Log";
import Loader from "./Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faApple } from "@fortawesome/free-brands-svg-icons/faApple";
import { faWindows } from "@fortawesome/free-brands-svg-icons/faWindows";
import { redirectToThankYouPage } from "../utils/routes";
import { downloadBuildboxClient } from "../utils/downloadsUtils";
import { DownloadPlatforms } from "../reducers/models";
import { cardSectionForProductName, logoSrcForProductName } from "../pages/Home";
import CardSection from "../components/home/CardSection";
import AdblockDetector from "../components/AdBlock";
import { isMobileDevice } from "../utils/browserUtils";
import { setProductType } from "../actions/current";
//import { waitForGAClientId } from "../utils/analyticsUtils";
import classnames from "classnames";
import { useSelector } from "react-redux";
import currentSaleContext from "../selectors/currentSaleContext";
import { fetchSale } from "../actions/sale";

import BBWInfoSection from "../components/BBWInfoSection.js";

import PromotionalBanner from "../components/PromotionalBanner";
import styles from "../styles/Downloads.module.scss";

export default function Downloads(props) {
  const dispatch = useDispatch();

  const { match } = props;
  const version = match.params.version;

  const [product, setProduct] = useState("");

  // banner setup
  const saleContext = useSelector(currentSaleContext);

  useEffect(() => {
    dispatch(fetchSale());
    //downloadOnLoad(); // disabled due to user feedback
    //eslint-disable-next-line
  }, []);

  useLayoutEffect(() => {
    const isMobile = isMobileDevice();

    if (isMobile) {
      if(version === "tools") {
        // TODO: what about other tools? we don't want to do any dispatching in that case since they don't have purchasable plans or other integrations around the site.
        //  for now it'll just act like desktop and presumably render useless download buttons or something
      }
      else {
        dispatch(setProductType(version));
        redirectToThankYouPage(props, "mobile");
      }
    }
    //eslint-disable-next-line
  }, []);

  useLayoutEffect(() => {
    if (version) {
      if (version === "bb4") {
        setProduct("BB4");
      }       
      else if (version === "bb3") {
        setProduct("BB3");
      } 
      else if (version === "bb2") {
        setProduct("BB2");
      } 
      else if (version === "soundbox") {
        setProduct("Soundbox")
      } 
      else if (version === "bbbundle") {
        setProduct(["BB4", "BB3", "BB2", "Soundbox"])
      }
      else if (version === "tools") {
        setProduct(["Pixelbox", "Animationbox", "Voxelbox"])
      }
      else {
        Log.trace(version, "unknown path found for version");
      }
    }
  }, [version]);

  function isValidVersion() {
    if (version) {
      if (version === "bb4" || version === "bb3" || version === "bb2" || version === "soundbox" || version === "bbbundle" || version === "tools") {
        return true;
      }
    }
    console.log("unrecognized product/version: ", version)
    return false;
  }

  /*
  function downloadOnLoad() {
    const ua = window.navigator.userAgent;

    const isSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;

    async function attemptToDownload() {
      try {
        if (version) {
          if (isValidVersion()) {
            const versionCased = version.toUpperCase();

            const response = await downloadBuildboxClient(null, versionCased);
            Log.info(
              "response from auto download on load after getting gcid",
              response
            );
          } else {
            return;
          }
        }
      } catch (e) {
        Log.error("attempt to download failed:", e);
      }
    }

    if (sessionStorage.getItem("adBlockEnabled") === "false") {
      if (isSafari) {
        document.onreadystatechange = function () {
          console.log("document readystatechange");
          if (document.readyState === "complete") {
            console.log("document complete");
            waitForGAClientId(attemptToDownload);
          }
        };
      } else {
        waitForGAClientId(attemptToDownload);
      }
    }
  }
    */

  function handleMacDownloadClick() {
    downloadBuildboxClient(DownloadPlatforms.MAC, product);
  }

  function handleWindowsDownloadClick() {
    downloadBuildboxClient(DownloadPlatforms.WINDOWS, product);
  }

  function handleMacDownloadClickGeneric(product) {
    downloadBuildboxClient(DownloadPlatforms.MAC, product);
  }

  function handleWindowsDownloadClickGeneric(product) {
    downloadBuildboxClient(DownloadPlatforms.WINDOWS, product);
  }

  function displayNameForCurrentProduct() {
    let checkStr = product.toLowerCase()
    if(checkStr === "bb4") {
      return "AI Using Buildbox 4!"
    }    
    else if(checkStr === "bb3") {
      return "Buildbox 3!"
    }
    else if(checkStr === "bb2") {
      return "AI Using Buildbox Classic!"
    }
    else if(checkStr === "soundbox") {
      return "Soundbox!"
    }
    else {
      //console.log("not sure what name to use for product '", checkStr, "'")
      return ""
    }    
  }

  function displayNameForCurrentProductGeneric(product) {
    let checkStr = product.toLowerCase()
    if(checkStr === "bb4") {
      return "Buildbox 4!"
    }
    else if(checkStr === "bb3") {
      return "Buildbox 3!"
    }
    else if(checkStr === "bb2") {
      return "AI Using Buildbox Classic!"
    }
    else if(checkStr === "soundbox") {
      return "Soundbox!"
    }
    else if(checkStr === "pixelbox") {
      return "Pixelbox"
    }
    else if(checkStr === "animationbox") {
      return "Animationbox"
    }
    else if(checkStr === "voxelbox") {
      return "Voxelbox"
    }
    else {
      //console.log("not sure what name to use for product '", checkStr, "'")
      return ""
    }    
  }
  
  function shouldShowLogoIconForProduct(product) {
    let checkStr = product.toLowerCase()
    if(checkStr === "bb4") {
      return true
    }
    else if(checkStr === "bb3") {
      return true
    }
    else if(checkStr === "bb2") {
      return true
    }
    else if(checkStr === "soundbox") {
      return true
    }
    else {
      return false
    }
  }
  
  function productHasCardSection(product) {
    let checkStr = product.toLowerCase()
    if(checkStr === "bb4") {
      return true
    }
    else if(checkStr === "bb3") {
      return true
    }
    else if(checkStr === "bb2") {
      return true
    }
    else if(checkStr === "soundbox") {
      return false // apparently we never made this guy a card section
    }
    else {
      return false
    }
  }

  function linkButtonWithTitleAndUrl(title, url) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        <button
          className={classnames(styles.downloadBtn)}
        >
          {title}
        </button>
      </a>
    )
  }

  function learnMoreButtonForProduct(product) {
    const checkStr = product.toLowerCase()
    if(checkStr === "pixelbox") {
      return linkButtonWithTitleAndUrl("Learn More", "https://www.buildbox.com/pixelbox-walkthrough")
    }
    else if(checkStr === "animationbox") {
      return linkButtonWithTitleAndUrl("Learn More", "https://www.buildbox.com/introducing-animationbox-2")
    }
    else if(checkStr === "voxelbox") {
      return linkButtonWithTitleAndUrl("Learn More", "https://www.buildbox.com/voxelbox-walkthrough")
    }
    else {
      return null
    }
  }

  //console.log("product: ", product, "version: ", version)

  if (!isValidVersion()) {
    console.log("unrecognized product/version: ", product, version)
    return <Redirect to={"/404"} />;
  }
  return (
      <AdblockDetector>
        <Suspense fallback={<Loader />}>
          <div
            className={classnames(styles.container, {
              [styles.promoBannerAdjust]: saleContext.showSaleUI,
            })}
          >
            <PromotionalBanner placement={"website_homepage"} router={props} />
            <div className={styles.header}>
              {typeof product === "string" && (
                <img
                  src={logoSrcForProductName(product)}
                  className={styles.BBLogo}
                  alt="Buildbox Logo"
                />
              )}
              <h3>Get Ready to Create Your Own Games</h3>
              {typeof product === "string" && (
                <h3 className={styles.gradientText}>
                  <span className={styles.whiteText}>With</span>
                  {displayNameForCurrentProduct()}
                </h3>
              )}
              <p>
                Your download may begin automatically, or you can select from the options below.
              </p>
            </div>
            <div className={styles.downloadsContainer}>
              <div className={styles.downloadButtonContainer}>
                <div className={styles.formContainer}>
                  {typeof product === "string" && (
                      <button
                        className={classnames(styles.downloadBtn, styles.mac)}
                        id="mac-download-btn"
                        onClick={handleMacDownloadClick}
                      >
                        <FontAwesomeIcon
                          className={styles.icon}
                          icon={faApple}
                        />
                        Download for Mac
                      </button>
                  )}
                  {typeof product === "string" && (
                      <button
                        className={classnames(styles.downloadBtn, styles.win)}
                        id="win-download-btn"
                        onClick={handleWindowsDownloadClick}
                      >
                        <FontAwesomeIcon
                          className={styles.icon}
                          icon={faWindows}
                        />
                        Download for Windows
                      </button>
                  )}
                  {Array.isArray(product) &&
                    product.map((p, index) => (
                      <div key={`product-section-${index}`}>
                        <h3 className={styles.gradientText}>
                          <span className={styles.whiteText}>Download </span>
                          {displayNameForCurrentProductGeneric(p)}
                          {shouldShowLogoIconForProduct(p) && <img
                            src={logoSrcForProductName(p)}
                            // className={styles.BBLogoBundle}
                            alt="Buildbox Logo"
                            width={20}
                          />}
                        </h3>
                        {/* squeezing in some extra info about XYZBox apps that don't have their own product pages */}
                        {learnMoreButtonForProduct(p)}
                        <button
                          className={classnames(
                            styles.downloadBtn,
                            styles.mac
                          )}
                          id="mac-download-btn"
                          onClick={() => handleMacDownloadClickGeneric(p)}
                        >
                          <FontAwesomeIcon
                            className={styles.icon}
                            icon={faApple}
                          />
                          Download for Mac
                        </button>
                        <button
                          className={classnames(
                            styles.downloadBtn,
                            styles.win
                          )}
                          id="win-download-btn"
                          onClick={() => handleWindowsDownloadClickGeneric(p)}
                        >
                          <FontAwesomeIcon
                            className={styles.icon}
                            icon={faWindows}
                          />
                          Download for Windows
                        </button>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          {product === "BB3" ? <BBWInfoSection /> : <span />}
          {typeof product === "string" && productHasCardSection(product) && (
              <CardSection
                key={`card-section-${product}`}
                {...cardSectionForProductName(product)}
              />
          )}
          {Array.isArray(product) &&
            product.map((p, index) => {
              if(productHasCardSection(p)) {
                return (
                  <CardSection
                  key={`card-section-${index}-${p}`}
                    {...cardSectionForProductName(p)}
                  />
                )
              }
              return null
            }
          )}
        </Suspense>
      </AdblockDetector>
  );
}
